import { Component, computed, inject, input } from '@angular/core';
import { FlatFilterDto, FlatItemDto, FlatService } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-building-flat-overview',
  templateUrl: './building-flat-overview.component.html',
  styleUrl: './building-flat-overview.component.scss'
})
export class BuildingFlatOverviewComponent {
  readonly flatService = inject(FlatService);
  readonly router = inject(Router);
  readonly formBuilder = inject(FormBuilder);
  readonly currentUserService = inject(CurrentUserService);

  readonly buildingId = input.required<string | null>();

  readonly canCreate = computed(() => {
    return this.currentUserService.hasPrivilege('canCreateUnits');
  });

  readonly loadFlats =
    (filter: FlatFilterDto) => this.flatService.findAll(this.prepareFlatFilter(filter));
  readonly getFlatCount =
    (filter: FlatFilterDto) => this.flatService.getCount(this.prepareFlatFilter(filter));

  flatListFilterForm!: FormGroup;

  constructor() {
    this.flatListFilterForm = this.formBuilder.group({
      buildingSectionIds: new FormControl([]),
      flatNumber: this.formBuilder.control(undefined),
      floor: this.formBuilder.control(undefined),
      doorNumber: this.formBuilder.control(undefined),
    });
  }

  readonly prepareFlatFilter = (filter: FlatFilterDto): FlatFilterDto => {
    const raw = this.flatListFilterForm.value as any;
    return {
      ...filter,
      ...(this.buildingId() ? { buildingId: this.buildingId()! } : {}),
      buildingSections: raw.buildingSectionIds || [],
    };
  };

  navigateToFlat(entry: FlatItemDto): void {
    this.router.navigate(['flat', entry.id], { queryParams: { buildingId: this.buildingId() } });
  }

  add(): void {
    this.router.navigate(['flat', 'new'], { queryParams: { buildingId: this.buildingId() } });
  }
}
